module.exports = "/Public/build/62db66677084632465f498db7b112b39.svg";


//////////////////
// WEBPACK FOOTER
// ./data/assets/feature-article-logo.svg
// module id = 268
// module chunks = 0